import React, { createElement, useContext, useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
import GroupTwoToneIcon from "@mui/icons-material/GroupTwoTone";
import WorkTwoToneIcon from "@mui/icons-material/WorkTwoTone";
import Diversity3SharpIcon from "@mui/icons-material/Diversity3Sharp";
import AddModeratorTwoToneIcon from "@mui/icons-material/AddModeratorTwoTone";
import KeyboardDoubleArrowRightSharpIcon from "@mui/icons-material/KeyboardDoubleArrowRightSharp";
import KeyboardDoubleArrowLeftSharpIcon from "@mui/icons-material/KeyboardDoubleArrowLeftSharp";
import PersonOutlineTwoToneIcon from "@mui/icons-material/PersonOutlineTwoTone";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import { Collapse, Tooltip, Stack } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MuiAppBar from "@mui/material/AppBar";
import { tooltipClasses } from "@mui/material/Tooltip";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import DepartmentManagement from "../DepartmentManagement";
import UserManagement from "../UserManagement";
import RoleManagement from "../RoleManagement";
import PageRightsAccess from "../PageRightAccess";
import CandidateResumeManagement from "../AddNewCandidate";
import CandidatePerformance from "../CandidatePerformance";
import { LoginContext } from "../../../contexts/loginContext";
import { CapitalizeName } from "../../../utils/capitalizeName";
import JobDescriptionManagementList from "../JobDescriptionManagementList";
import OrganizationDashboard from "../OrganizationDashboard";
import ScheduleInterview from "../ScheduleInterview";
import ListInterview from "../ListInterview";
import ViewCandidate from "../ViewCandidate";
import JobDescription from "../JobDescription";
import AddNewCandidate from "../AddNewCandidate";
import UpcomingInterviews from "../UpcomingInterviews";
import CompletedInterviews from "../CompletedInterviews";
import CandidatesHiredRejected from "../CandidatesHiredRejected";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Redux/slices/authSlice";
import createInstance from "../../../api/axiosinstance";

const drawerWidth = 300;

const openedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  borderTopRightRadius: 30,
  borderBottomRightRadius: 30,
  backgroundColor: "#006A71",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  borderTopRightRadius: 30,
  borderBottomRightRadius: 30,
  backgroundColor: "#006A71",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  backgroundColor: "#1E1E1E",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  borderRadius: 10,
  backgroundColor: "#1E1E1E",
  marginTop: 15,
  marginRight: 20,
  width: `calc(100% - 7%)`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth + 40}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  })
);
const OranizationLandingPage = ({ title }) => {
  const aiDishaApi = createInstance("DISHA");
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [menudata, setMenudata] = useState("Dashboard");
  const [titleText, setTitleText] = useState("Dashboard");
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  // const [organizationData, setOrganizationData] = React.useState(null);
  const userName = CapitalizeName(user?.name || "");
  const navigate = useNavigate();

  const icons = [
    HomeTwoToneIcon,
    AddModeratorTwoToneIcon,
    PersonOutlineTwoToneIcon,
    Diversity3SharpIcon,
    GroupTwoToneIcon,
    WorkTwoToneIcon,
  ];

  const handleListItemClick = (item) => {
    setMenudata(item);
    setTitleText(item);
    setShowCreateNewJob(false);
    setShowCreateNewCandidate(false);
  };

  const [open, setOpen] = useState(false);
  const [showCreateNewJob, setShowCreateNewJob] = useState(false);
  const [showCreateNewCandidate, setShowCreateNewCandidate] = useState(false);

  const handleOpenCreateNewJob = () => {
    setMenudata("");
    setTitleText("Create New Job");
    setShowCreateNewJob(true);
  };

  const handleOpenCreateNewCandidate = () => {
    setMenudata("");
    setTitleText("Add Candidate");
    setShowCreateNewCandidate(true);
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    setTimeout(() => navigate("/"), 0);
  };

  const organizationName = user?.organization?.organization_name;
  const organizationid = user?.organizationId;
  const organizationLogo = user?.organization?.organization_logo_url;

  const [organizationDetails, setOrganizationDetails] = useState(null);

  useEffect(() => {
    const fetchOrganization = async () => {
     try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching organization data for user:', user);
        
        // Get organization ID from user data
        const orgId = user?.organizationId;
        if (!orgId) {
          setError('No organization ID found in user data');
          return;
        }
        
        const response = await aiDishaApi.get(`/get_organization_by_id?org_id=${orgId}`);
        
        console.log('API Response status:', response.status);
        
        if (response.status === 200 && response.data) {
          const data = response.data;
          console.log('Full API Response:', data);
          
          // Handle both response formats
          const orgData = data.organization || data; // Check if data is nested under 'organization' key
          console.log('Organization data received from API:', orgData);
          console.log('Logo URL from API:', orgData.organization_logo_url);
          setOrganizationDetails(orgData);
        } else {
          console.warn('API call failed, checking user data...');
          
          const fallbackData = {
            organization_id: user?.organizationId,
            organization_name: user?.organizationName,
            organization_logo_url: user?.organizationLogoUrl,
            organization_domain: user?.organizationDomain,
          };
          
          if (fallbackData.organization_id) {
            console.log('Using fallback data:', fallbackData);
            setOrganizationDetails(fallbackData);
          } else {
            const errorText = await response.text();
            console.error('API error response:', errorText);
            setError(`Failed to fetch organization data: ${response.status}`);
          }
        }
      } catch (error) {
        console.error('Network error fetching organization data:', error);
        setError(`Network error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };


    fetchOrganization();
  }, [organizationid]);

  const fixLinodeUrl = (url) => {
    if (!url) return null;
    
    // Fix the SSL certificate issue by using the correct Linode Object Storage format
    // From: https://ai-codedisha.s3.in-maa-1.linodeobjects.com/...
    // To: https://in-maa-1.linodeobjects.com/ai-codedisha/...
    if (url.includes('ai-codedisha.s3.in-maa-1.linodeobjects.com')) {
      return url.replace(
        'ai-codedisha.s3.in-maa-1.linodeobjects.com',
        'in-maa-1.linodeobjects.com/ai-codedisha'
      );
    }
    
    return url;
  };

  const organizationMasterOptions = [
    "Role Management",
    "Department Management",
    // "Page access rights",
  ];

  const candidateManagementOptions = [
    "View Candidate",
    // "Candidate Performance",
    "Candidates Hired",
    "Candidates Rejected",
  ];

  return (
    <Box sx={{ display: "flex", backgroundColor: "#f4f9e9" }}>
      <AppBar position="fixed" open={open} sx={{ background: "#006A71" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="h5"
              color="white"
              sx={{ fontSize: "20px", textAlign: "left" }}
            >
              {titleText}
            </Typography>
          </Box>
          <Button
            sx={{
              display: { xs: "none", sm: "flex" },
              border: "1px solid #B9B9B9",
              color: "#B9B9B9",
              height: "45px",
              width: "148px",
              borderRadius: "10px",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <ExitToAppIcon />
            Export
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ position: "relative" }}>
          <Box
            sx={{
              backgroundColor: "white",
              width: "100%",
              height: "100%",
              padding: "10px",
              borderRadius: "10px 30px 0px 20px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: "10px",
            }}
          >
            {isAuthenticated && (
              <>
                {organizationDetails?.organization_logo_url && (
                  <Box
                    component="img"
                    src={fixLinodeUrl(organizationDetails?.organization_logo_url)}
                    alt="Org Logo"
                    sx={{
                      width: "100px",
                      height: "50px",
                      // borderRadius: "20%",
                      objectFit: "cover",
                    }}
                  />
                )}

                {organizationDetails?.organization_name && (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#333",
                      maxWidth: "160px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {organizationDetails?.organization_name}
                  </Typography>
                )}

                <LightTooltip title={`${user?.name || ""}`} placement="right">
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#1E1E1E",
                      maxWidth: "160px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: open ? "block" : "none",
                    }}
                  >
                    Welcome {userName}
                  </Typography>
                </LightTooltip>
              </>
            )}
          </Box>
        </DrawerHeader>
        <DrawerHeader>
          <IconButton
            color="white"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{ color: "white", marginRight: 1, marginLeft: 1 }}
          >
            {open ? (
              <KeyboardDoubleArrowLeftSharpIcon />
            ) : (
              <KeyboardDoubleArrowRightSharpIcon />
            )}
          </IconButton>
        </DrawerHeader>

        <List sx={{ color: "white" }}>
          {[
            "Dashboard",
            "Organization Master",
            "User Management",
            "Candidate Management",
          ].map((text, index) => (
            <ListItem
              key={text}
              disablePadding
              onClick={() => handleListItemClick(text)}
            >
              <ListItemButton>
                <ListItemIcon sx={{ color: "white" }}>
                  <LightTooltip title={text}>
                    {createElement(icons[index % icons.length])}
                  </LightTooltip>
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <DrawerHeader>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{ color: "white", marginRight: 1 }}
          >
            <Stack direction="column" spacing={1}>
              {open ? (
                <KeyboardDoubleArrowLeftSharpIcon />
              ) : (
                <KeyboardDoubleArrowRightSharpIcon />
              )}
              {isAuthenticated && (
                <div onClick={handleLogOut} title="Logout">
                  <LogoutIcon />
                </div>
              )}
            </Stack>
          </IconButton>
        </DrawerHeader>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          height: "100vh",
          backgroundColor: "white",
          overflow: "auto",
        }}
      >
        <DrawerHeader />

        {menudata === "Dashboard" && <OrganizationDashboard />}
        {menudata === "Organization Master" && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: 4,
              mt: 8,
              mx: 7,
            }}
          >
            {organizationMasterOptions.map((option) => (
              <Card key={option} sx={{ maxWidth: 250,bgcolor: "#006A71", minHeight: 100 }}>
                <CardActionArea onClick={() => handleListItemClick(option)}>
                  <CardContent>
                    <Typography variant="h6" component="div">
                      {option}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Box>
        )}
        {menudata === "Candidate Management" && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: 4,
              mt: 8,
              mx: 7,
            }}
          >
            {candidateManagementOptions.map((option) => (
              <Card key={option} sx={{ maxWidth: 250, bgcolor: "#006A71", minHeight: 100 }}>
                <CardActionArea onClick={() => handleListItemClick(option)}>
                  <CardContent>
                    <Typography variant="h6" component="div">
                      {option}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Box>
        )}
        {menudata === "Department Management" && <DepartmentManagement />}
        {menudata === "Role Management" && <RoleManagement />}
        {menudata === "User Management" && <UserManagement />}
        {menudata === "Page access rights" && <PageRightsAccess />}
        {menudata === "View Candidate" && (
          <ViewCandidate onOpenCandidate={handleOpenCreateNewCandidate} />
        )}
        {showCreateNewCandidate && <AddNewCandidate />}
        {menudata === "Candidate Performance" && <CandidatePerformance />}
        {menudata === "Candidates Hired" && (
          <CandidatesHiredRejected value="Hired" />
        )}
        {menudata === "Candidates Rejected" && (
          <CandidatesHiredRejected value="Rejected" />
        )}
        {menudata === "Schedule Interview" && <ScheduleInterview />}
        {menudata === "List Interview" && <ListInterview />}
        {menudata === "Upcoming Interviews" && <UpcomingInterviews />}
        {menudata === "Completed Interviews" && <CompletedInterviews />}
        {menudata === "Create New Job" && <JobDescription />}
        {menudata === "View Existing Jobs" && (
          <JobDescriptionManagementList
            onOpenJobDescription={handleOpenCreateNewJob}
          />
        )}
        {showCreateNewJob && <JobDescription />}
      </Box>
    </Box>
  );
};

export default OranizationLandingPage;